<template>
  <basic-container>
    <mc-empty-content />
  </basic-container>
</template>


<script>
import McEmptyContent from "./../../../blocks/mc-empty-content/index.js";

export default {
  components: {
    McEmptyContent
  }
};
</script>